import React from 'react';
import { Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';
import logoImage from '../assets/logo.png';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div className="space-y-4">
            <img src={logoImage} alt="iXus Group Limited" className="h-12 w-auto brightness-0 invert" />
            <p className="text-gray-400 text-sm leading-relaxed">
              Leading provider of HVAC, Electrical, and Door Automation solutions. Excellence in every project.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2 text-gray-400">
              <li>
                <a href="#hvac" className="hover:text-[#8B1818] transition-colors duration-200">
                  HVAC Solutions
                </a>
              </li>
              <li>
                <a href="#electrical" className="hover:text-[#8B1818] transition-colors duration-200">
                  Electrical Services
                </a>
              </li>
              <li>
                <a href="#door-automation" className="hover:text-[#8B1818] transition-colors duration-200">
                  Door Automation
                </a>
              </li>
              <li>
                <a href="#about" className="hover:text-[#8B1818] transition-colors duration-200">
                  About Us
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-bold text-lg mb-4">Services</h3>
            <ul className="space-y-2 text-gray-400">
              <li>
                <a href="#" className="hover:text-[#8B1818] transition-colors duration-200">
                  Installation
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-[#8B1818] transition-colors duration-200">
                  Maintenance
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-[#8B1818] transition-colors duration-200">
                  Repairs
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-[#8B1818] transition-colors duration-200">
                  Consulting
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-bold text-lg mb-4">Contact</h3>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li>Unit 7 Kenfig Industrial Estate</li>
              <li>Margam, Port Talbot</li>
              <li>SA13 2PE</li>
              <li className="pt-2">
                <a href="tel:01639618481" className="hover:text-[#8B1818] transition-colors duration-200">
                  01639 618 481
                </a>
              </li>
              <li>
                <a href="mailto:info@ixusgroup.com" className="hover:text-[#8B1818] transition-colors duration-200">
                  info@ixusgroup.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Social Media & Copyright */}
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            © {currentYear} iXus Group Limited. All rights reserved.
          </p>
          
          <div className="flex gap-4">
            <a
              href="#"
              className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-[#8B1818] transition-colors duration-200"
            >
              <Facebook size={20} />
            </a>
            <a
              href="#"
              className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-[#8B1818] transition-colors duration-200"
            >
              <Twitter size={20} />
            </a>
            <a
              href="#"
              className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-[#8B1818] transition-colors duration-200"
            >
              <Linkedin size={20} />
            </a>
            <a
              href="#"
              className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-[#8B1818] transition-colors duration-200"
            >
              <Instagram size={20} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;